import styled from 'styled-components';

export const EmailResetForm = styled.div`
    padding : calc(100vw*(35/375)) calc(100vw*(30/375)) 0;
`

export const FieldList = styled.div`
	padding-bottom : calc(100vw*(30/375));
`

export const FormTitle = styled.span`
    display: block;
    font-size: calc(100vw*(14/375));
    font-weight: 500;
    padding-bottom :calc(100vw*(8/375));
`

export const PasswordField = styled.input`
    display : block;
    width: calc(100vw*(309/375));
    height: calc(100vw*(41/375));
    border-radius: calc(100vw*(5/375));
    border: solid calc(100vw*(1/375)) #d5d5d5;
    font-size: calc(100vw*(14/375));
    padding :0 calc(100vw*(11/375)) ;
    margin-bottom: calc(100vw*(5/375));
    &::placeholder {
        color: #c6c6c6;
        font-size: calc(100vw*(14/375));
    }
    &:focus {
        border: solid calc(100vw*(1/375)) #ffcf19;
    }
`

export const ErrorMessage = styled.div`
	font-size: calc(100vw*(10/375));
	line-height: calc(100vw*(14/375));
	color: #DE0000;
	display: flex;
	align-items: center;
`

export const WarningImg = styled.img`
	width : calc(100vw*(10/375));
	height: calc(100vw*(9/375));
	margin-right: calc(100vw*(4/375));
`
